import PropTypes from 'prop-types';

const CarouselContainer = ({ children, isBuilding }) => {  

return (

    <div className={`container-root container-root-maxWidthLg carousel-container-main ${ isBuilding ? 'carousel-container-buildings-settings' : 'carousel-container-settings'}`}>
      {children}
    </div>

  );
};

CarouselContainer.propTypes = {
  isBuilding: PropTypes.bool,
  children: PropTypes.any,
};

export default CarouselContainer;
